<template>
    <div class="container-mob w-100">
        <img src="/assets/img/logo.png" class="img-fluid logo-header mb-5">
        <div class="form-login mt-5">
            <h2 class="mb-3">Restablecer Contraseña</h2>

            <div class="notification text-danger"v-if="errors">
                <ul>
                    <ul v-for="(fields, key) in errors">
                        <b>{{ key }}:</b>
                        <li v-for="error in fields">{{error}}</li>
                    </ul>
                </ul>
            </div>
            <div v-if="resetOK" class="notification text-success" role="alert">
                <p>{{ resetOK }}</p>
                <div class="text-center my-5">
                    <button type="submit" class="btn-form btn-success" @click="iniciarSesion">INICIAR SESIÓN</button>
                </div>
            </div>
            <form @submit.prevent="sendReset" method="post" v-else>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon3"><i class="fas fa-envelope"></i></span>
                    <input type="email" class="form-control" placeholder="Email" aria-label="Email" aria-describedby="basic-addon3" name="email" id="email" v-model="email" readonly>
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon2"><i class="fas fa-unlock-alt"></i></span>
                    <input type="password" class="form-control" placeholder="Escribe Tu Nueva Contraseña" aria-label="Contraseña" aria-describedby="basic-addon2" name="password" v-model="password">
                </div>
                <div class="input-group">
                    <span class="input-group-text" id="basic-addon4"><i class="fas fa-unlock-alt"></i></span>
                    <input type="password" class="form-control" placeholder="Confirmar Nueva Contraseña" aria-label="Contraseña" aria-describedby="basic-addon2" name="password_confirmation" v-model="password_confirmation">
                </div>

                <div class="text-center mt-5">
                    <button type="submit" class="btn-form">CAMBIAR CONTRASEÑA</button>
                </div>

            </form>
        </div>
    </div>


</template>

<script>
export default {
    data() {
        return {
            email: null,
            password: null,
            password_confirmation: null,
            errors: null,
            resetOK: null
        };
    },
    methods: {
        sendReset() {
            let token = new URLSearchParams(window.location.search).get('token');
            this.$store
            .dispatch("postResetPassword", {
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                token: token
            })
            .then(response => {
                this.resetOK = response.data.status;
            })
            .catch(error => {
                this.errors = error.response.data.errors;
            });
        },
        iniciarSesion(){
            this.$router.push({name: "login"});
        }
    },
    mounted: function () {
        this.email = new URLSearchParams(window.location.search).get('email');
    }
};
</script>

<style>
.logo-header {
    max-width: 150px;
}

.input-group-text {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #989898;
    width: 40px;
    margin-left: auto;
    margin-right: auto;
}

.input-group > .form-control, .input-group > .form-select {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
}

.input-group:last-child {
    border-top: 1px solid #EDEDED;
}

.input-group input:focus {
    box-shadow: none;
}

.input-group input::placeholder {
    font-size: 14px;
}

.btn-form {
    background: #F9423E;
    color: white;
    border-radius: 100px;
    text-align: center;
    padding: 5px 40px;
    border: 0px;
    margin-left: auto;
    margin-right: auto;
}

.enlace-form a {
    color: #989898;
    font-size: 12px;
    text-decoration: none;
}
</style>
